export function a11yProps(index: number) {
  return {
    id: `enhanced-tab-${index}`,
    'aria-controls': `enhanced-tabpanel-${index}`,
  }
}
